import React from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import { getTransactionList } from "../../api/transaction-list";
import { useState, useEffect } from "react";
import { Paper, Grid, Box, Typography, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import { createSlug } from "../../config/slug-config";

export default function TransactionList() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token) {
      getTransactionListTableData();
      setPages(
        JSON.parse(user?.page_access?.replace("{", "[").replace("}", "]"))
      );
    }
  }, [user.token]);

  const [rowData, setRowData] = useState([]);

  async function getTransactionListTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionList(user.token);
      setRowData(data.data.data);
      setLoading(true);
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
    } finally {
      setLoading(false);
    }
  }
  // const sortedTran = rowData?.sort((a, b) => a.fullname.localeCompare(b.fullname));
  // const sortedTran = rowData
  //   ?.map((item) => {
  //     return {
  //       ...item, 
  //       fullname:
  //         item.fullname === "CUSTOM" ? "AP Check Request" : item.fullname, 
  //     };
  //   })
  //   .sort((a, b) => a.fullname.localeCompare(b.fullname));
console.log(rowData,"rowData")
  return loading ? (
    <>
      <Box pl={0}>
        <Typography className="pageHeading" pl={0}>
          Transaction Type
        </Typography>
      </Box>
      <Grid container spacing={2} className="cardWrapper">
        <div
          style={{
            width: "100%",
            height: "510px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <CircularProgress size={100} />
          <div
            style={{
              position: "absolute",
              top: "70%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "20px",
              color: "#888",
              animation: "fadeIn 2s ease-in-out",
            }}
          >
            Please wait while loading...
          </div>
        </div>
      </Grid>
    </>
  ) : (
    <>
      <Box pl={0}>
        <Typography className="pageHeading" pl={0}>
          Transaction Type
        </Typography>
      </Box>
      <Grid container spacing={2} className="cardWrapper">
        {rowData?.map((d, i) =>
        
            <Grid
              item
              key={i}
              xl={2}
              lg={3}
              md={4}
              sm={6}
              xs={12}
              className="trans-card"
            >
              <Paper elevation={2} sx={{ p: 2 }} className="trans-card-bkg">
                <Link to={"/transaction-type/" + (d.fullname === "AP CHECK" ? "custom" : createSlug(d.fullname))}>
                  <Grid
                    item
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="transList"
                  >
                    <div className="transListText">
                      <div className="totalRec">
                        <span className="transCardIcon">{d.abbrevtype === "RCPT" ? "CS":d.abbrevtype }</span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item key={i} xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div className="card-text">
                      <p className="transListName">{d.fullname}</p>
                    </div>
                  </Grid>
                </Link>
              </Paper>
            </Grid>
         
        )}
      </Grid>
    </>
  );
}
